module.exports = __webpack_public_path__ + "static/media/pagina1-boompje3_tijdslijn.8057b237.svg";